import React from 'react';
import Logger from '../../util/Logger';
import './ResponseGroup.css';
import { ResponseCard } from './ResponseCard';
import Response from '../../models/Response';

export class ResponseGroup extends React.Component {

  constructor (props) {
    super(props);

    if (!props.response) {
      Logger.assert('Must construct ResponseGroup with a Response object');
    }
  }

  render () {
    const { response, onItemClicked, noteworthy, votingMode } = this.props;
    const children = Response.getChildrenCount(response) > 0 ? Response.getChildren(response) : [];
    return (
      <div className="col no-gutters response-group">
        <div className="group-divider" />
        <ul>
          <ResponseCard
            response={ response }
            votingMode={ votingMode }
            isChild={ false }
            onItemClicked={ onItemClicked }
            noteworthy={ noteworthy } />
        </ul>

        { (!!children && children.length > 0) && (
          <ul>
            { children.map(c => (
              <div
                key={ Response.getId(c) }
                className="group-child">
                <div className="child-divider-container">
                  <div className="card-divider" />
                </div>
                <ResponseCard
                  noteworthy={ noteworthy }
                  response={ c }
                  votingMode={ votingMode }
                  isChild={ true }
                  onItemClicked={ onItemClicked } />
              </div>
            )) }
          </ul>
        ) }
      </div>
    );
  }
}
